import React from 'react';

// [글래스 로그인 팝업 2026-10-26] 글래스(에이치루브 앱)가 current-user로 참가자를 조회했을 때 진행자 화면에 띄우는 팝업
// SocketProvider에서 렌더링 (모든 화면 공통). Swal을 쓰면 열려 있는 결과 팝업을 대체하므로 React 컴포넌트로 만듦

// 로그인 시각: 서버가 보낸 ISO(UTC)를 KST yyyy-MM-dd HH:mm으로 표시
const formatKst = (iso) => {
  const date = new Date(iso);
  if (!iso || Number.isNaN(date.getTime())) return '';
  // sv-SE 형식이 yyyy-MM-dd HH:mm
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    // hour12: false는 일부 브라우저에서 자정을 24시로 표시하므로 h23 사용
    hourCycle: 'h23',
  }).format(date);
};

// [글래스 로그인 팝업 2026-10-27] 지갑주소 전체 표시로 바꿔 쓰지 않음 — 원래 코드 보존
// // 지갑주소: 앞 6자리…뒤 4자리 (0x 포함, 예시 이미지 기준)
// const shortWallet = (address) => {
//   const value = address || '';
//   if (value.length <= 10) return value;
//   return `${value.slice(0, 6)}…${value.slice(-4)}`;
// };

// [글래스 로그인 팝업 디자인 2026-10-27] 지갑 디자인에서 배지 아이콘을 쓰지 않음 — 원래 코드 보존
// // 배지 아이콘: 연결됨 = 안경
// const GlassesIcon = () => (
//   <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//     <circle cx="6" cy="15" r="4" />
//     <circle cx="18" cy="15" r="4" />
//     <path d="M10 15a2 2 0 0 1 4 0" />
//     <path d="M2.5 13 5 7c.7-1.3 1.4-2 3-2" />
//     <path d="M21.5 13 19 7c-.7-1.3-1.5-2-3-2" />
//   </svg>
// );
//
// // 배지 아이콘: 참여 완료 = 느낌표 원
// const AlertCircleIcon = () => (
//   <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//     <circle cx="12" cy="12" r="10" />
//     <line x1="12" y1="8" x2="12" y2="12" />
//     <line x1="12" y1="16" x2="12.01" y2="16" />
//   </svg>
// );

// [글래스 로그인 팝업 디자인 2026-10-27] 로고 타일 크기·테두리 변경 — 원래 코드 보존
// // 로고: 기존 로고 PNG(아이콘 + 글자)에서 왼쪽 아이콘 부분만 잘라 흰 둥근 타일에 얹음
// const LogoTile = () => (
//   <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white">
//     <div className="relative h-6 w-6 overflow-hidden">
//       <img
//         src="/image/3d_asset_dataspace.png"
//         alt=""
//         className="absolute"
//         style={{ height: 36, width: 'auto', maxWidth: 'none', left: -3, top: -6 }}
//       />
//     </div>
//   </div>
// );
// [글래스 로그인 팝업 디자인 2026-10-27] 로고 타일 38px(흰 바탕, 테두리 #E3E5EF, 모서리 10px). 같은 PNG 아이콘 자르기를 28px 영역에 비율대로 키움 (24px → 28px, ×7/6)
const LogoTile = () => (
  <div className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-[10px] border border-[#E3E5EF] bg-white">
    <div className="relative h-7 w-7 overflow-hidden">
      <img
        src="/image/3d_asset_dataspace.png"
        alt=""
        className="absolute"
        style={{ height: 42, width: 'auto', maxWidth: 'none', left: -3.5, top: -7 }}
      />
    </div>
  </div>
);

const GlassLoginPopup = ({ data, onClose }) => {
  if (!data) return null;

  const nickName = data.nickName || '';
  const rewarded = data.rewarded === true;

  // [글래스 로그인 팝업 디자인 2026-10-27] 기존 카드 디자인 — 원래 코드 보존
  // return (
  //   // z-index는 진행 중 로딩(1050)·Swal(1060)보다 낮게
  //   <div className="fixed inset-0 z-[1040] flex items-center justify-center bg-black bg-opacity-50 px-4">
  //     <div role="dialog" aria-modal="true" className="w-full max-w-[480px] rounded-[28px] bg-white px-6 pb-6 pt-7 shadow-xl sm:px-8 sm:pb-8">
  //       {/* 상단 배지 + 문구 */}
  //       <div className="flex flex-col items-center text-center">
  //         {rewarded ? (
  //           <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-50 px-3 py-1.5 text-sm font-semibold text-orange-600">
  //             <AlertCircleIcon />
  //             참여 완료
  //           </span>
  //         ) : (
  //           <span className="inline-flex items-center gap-1.5 rounded-full bg-green-50 px-3 py-1.5 text-sm font-semibold text-green-700">
  //             <GlassesIcon />
  //             스마트 글래스 연결됨
  //           </span>
  //         )}
  //         {rewarded ? (
  //           <>
  //             <p className="mt-3 break-all text-xl font-bold leading-snug text-gray-900">
  //               {nickName}님은 이미 참가한 사용자입니다
  //             </p>
  //             <p className="mt-1 text-base text-gray-600">다음 참가자로 로그인해 주세요</p>
  //           </>
  //         ) : (
  //           <p className="mt-3 break-all text-xl font-bold leading-snug text-gray-900">
  //             {nickName}님이 스마트 글래스에 로그인하였습니다
  //           </p>
  //         )}
  //       </div>
// 
  //       {/* DID 지갑 카드 */}
  //       <div className="relative mt-6 overflow-hidden rounded-2xl bg-[#26307A] px-6 py-6 text-white">
  //         {/* 오른쪽 위 동심원 장식 */}
  //         <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full border border-white/10" />
  //         <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full border border-white/10" />
  //         <div className="pointer-events-none absolute right-0 top-0 h-24 w-24 rounded-full border border-white/10" />
// 
  //         <div className="relative">
  //           <div className="flex items-center gap-2.5">
  //             <LogoTile />
  //             <span className="text-sm font-semibold">3D Asset Data Space</span>
  //           </div>
// 
  //           <p className="mt-6 text-xs text-white/70">보유자</p>
  //           <p className="mt-1 break-all text-2xl font-bold">{nickName}</p>
  //           <p className="mt-1 break-all font-mono text-sm text-white/80">{data.userDid}</p>
// 
  //           <p className="mt-5 text-xs text-white/70">지갑주소</p>
  //           {/* [글래스 로그인 팝업 2026-10-27] 지갑주소 전체 표시 (break-all로 카드 안에서 줄바꿈) */}
  //           {/* <p className="mt-1 break-all font-mono text-sm font-semibold">{shortWallet(data.walletAddress)}</p> */}
  //           <p className="mt-1 break-all font-mono text-sm font-semibold">{data.walletAddress || ''}</p>
  //         </div>
  //       </div>
// 
  //       {/* 로그인 시각: 왼쪽 라벨, 오른쪽 값 */}
  //       <div className="mt-5 flex items-center justify-between gap-4 text-sm text-gray-500">
  //         <span className="shrink-0">로그인 시각</span>
  //         <span>{formatKst(data.calledAt)}</span>
  //       </div>
// 
  //       {/* 확인: 닫기만 (서버 호출 없음), 버튼 스타일은 당첨 팝업과 같음 */}
  //       <button
  //         type="button"
  //         onClick={onClose}
  //         className="mt-6 inline-flex w-full justify-center rounded-xl bg-[#5a45e6] px-4 py-3 text-[15px] font-semibold text-white hover:bg-[#4a37d0] focus:outline-none"
  //       >
  //         확인
  //       </button>
  //     </div>
  //   </div>
  // );

  // [글래스 로그인 팝업 디자인 2026-10-27] 디지털 지갑 디자인
  // 휴대폰(sm 미만)은 기본값, 데스크톱(sm 이상)은 sm: 값. 화면 높이가 모자라면 본문만 팝업 안에서 스크롤, 확인 버튼은 항상 보임 (02-fix 결과 팝업과 같은 방식)
  return (
    // z-index는 진행 중 로딩(1050)·Swal(1060)보다 낮게
    <div className="fixed inset-0 z-[1040] flex items-center justify-center bg-black bg-opacity-50 px-4 py-4">
      <div
        role="dialog"
        aria-modal="true"
        className="flex max-h-[calc(100vh-2rem)] w-full max-w-[420px] flex-col rounded-[24px] bg-[#F3F4F9] p-4 shadow-xl supports-[height:100dvh]:max-h-[calc(100dvh-2rem)] sm:p-5"
      >
        <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto">
          {/* 머리 */}
          <div className="flex shrink-0 items-center justify-between gap-3">
            <p className="text-[18px] font-bold text-[#1B1E2E]">스마트 글래스 로그인</p>
            <span className="shrink-0 text-[12px] text-[#5F6478]">내 지갑</span>
          </div>

          {/* 지갑: 뒤 패스 2장 → 신원증명 패스 → 앞주머니 */}
          <div className="relative h-[270px] shrink-0 overflow-hidden rounded-[24px] bg-[#26307A] sm:h-[290px]">
            <div className="absolute left-[40px] right-[40px] top-[10px] h-[40px] rounded-[14px] bg-[#6B74C8]" />
            <div className="absolute left-[28px] right-[28px] top-[17px] h-[40px] rounded-[14px] bg-[#8E95D8]" />

            {/* 신원증명 패스 (참여 완료면 바탕 #F4F5F8 + 도장). 휴대폰은 첫 줄 글자·간격과 보유자 위 간격을 줄여 폭 360px·앞주머니에 맞춤 */}
            <div className={`absolute left-[18px] right-[18px] top-[26px] h-[190px] rounded-[18px] px-[18px] py-[16px] sm:h-[200px] ${rewarded ? 'bg-[#F4F5F8]' : 'bg-white'}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex min-w-0 items-center gap-2 sm:gap-2.5">
                  <LogoTile />
                  <div className="min-w-0">
                    <p className="truncate text-[12px] font-bold text-[#1B1E2E] sm:text-[13px]">3D Asset Data Space</p>
                    <p className="truncate text-[11px] text-[#5F6478]">디지털 신원증명</p>
                  </div>
                </div>
                <span className="shrink-0 rounded-full bg-[#E8EAF6] px-2 py-1 text-[11px] font-bold text-[#26307A] sm:px-2.5">DID</span>
              </div>

              <p className="mt-3 text-[11px] text-[#5F6478] sm:mt-4">보유자</p>
              <div className="mt-0.5 flex items-center justify-between gap-2">
                <p className="min-w-0 truncate text-[24px] font-bold leading-tight text-[#1B1E2E] sm:text-[26px]">{nickName}</p>
                {/* 도장 글자색: 시안 #B85A0C는 패스 바탕 #F4F5F8 대비 4.3:1이라 4.5:1을 넘는 #AC530B로 조금 어둡게 */}
                {rewarded && (
                  <span className="shrink-0 -rotate-[8deg] rounded-[8px] border-2 border-[#AC530B] px-2 py-0.5 text-[13px] font-bold text-[#AC530B]">
                    참여 완료
                  </span>
                )}
              </div>
            </div>

            {/* 앞주머니: 패스 아래쪽을 덮음. 문구는 최대 2줄(line-clamp-2), 그래도 넘치면 위로 늘어남 (min-h) */}
            <div className="absolute inset-x-0 bottom-0 min-h-[116px] rounded-t-[22px] bg-[#1B2260] p-[10px] shadow-[0_-10px_20px_rgba(8,10,40,.35)] sm:min-h-[120px]">
              <div className="flex min-h-[96px] flex-col justify-center rounded-[16px] border-[1.5px] border-dashed border-white/30 px-4 py-2 sm:min-h-[100px] sm:py-2.5">
                {rewarded ? (
                  <>
                    <span className="self-start rounded-full bg-[#F5A54A] px-2.5 py-0.5 text-[12px] font-bold text-[#1B2260]">참여 완료</span>
                    <p className="mt-1.5 line-clamp-2 break-all text-[14px] leading-snug text-white">
                      {nickName}님은 이미 참가한 사용자입니다
                    </p>
                    <p className="mt-1 text-[12.5px] text-[#C9CDEB]">다음 참가자로 로그인해 주세요</p>
                  </>
                ) : (
                  <>
                    <span className="flex items-center gap-2 text-[13px] font-bold text-[#7BE3A6]">
                      <span className="h-2 w-2 shrink-0 rounded-full bg-[#3DDC84]" aria-hidden="true" />
                      스마트 글래스 연결됨
                    </span>
                    <p className="mt-1.5 line-clamp-2 break-all text-[14px] leading-snug text-white">
                      {nickName}님이 스마트 글래스에 로그인하였습니다
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>

          {/* 정보: DID / 지갑주소(02-fix 전체 표시 유지) / 로그인 시각 */}
          <div className="shrink-0 divide-y divide-[#ECEEF4] rounded-[16px] bg-white px-4">
            <div className="py-3">
              <p className="text-[12px] text-[#5F6478]">DID</p>
              <p className="mt-1 break-all font-mono text-[12px] leading-[1.55] text-[#1B1E2E] sm:text-[12.5px]">{data.userDid}</p>
            </div>
            <div className="py-3">
              <p className="text-[12px] text-[#5F6478]">지갑주소</p>
              <p className="mt-1 break-all font-mono text-[12px] leading-[1.55] text-[#1B1E2E] sm:text-[12.5px]">{data.walletAddress || ''}</p>
            </div>
            <div className="flex items-center justify-between gap-4 py-3">
              <span className="shrink-0 text-[12px] text-[#5F6478]">로그인 시각</span>
              <span className="text-[13px] text-[#1B1E2E]">{formatKst(data.calledAt)}</span>
            </div>
          </div>
        </div>

        {/* 확인: 닫기만 (서버 호출 없음) */}
        <button
          type="button"
          onClick={onClose}
          className="mt-4 inline-flex h-[52px] w-full shrink-0 items-center justify-center rounded-[14px] bg-[#5B47E0] text-[16px] font-bold text-white hover:bg-[#4B38CC] focus:outline-none"
        >
          확인
        </button>
      </div>
    </div>
  );
};

export default GlassLoginPopup;
